import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PortalShell from "@/portal/PortalShell";
import { PageHeader, EmptyState, ErrorState, SkeletonRows, IconTile } from "@/portal/ui/Layout";
import { Select } from "@/portal/ui/Field";
import { Button } from "@/portal/ui/Button";
import { DocumentsTable } from "@/portal/DocumentsTable";
import PmContactModal from "@/portal/PmContactModal";
import { FileText, Users, ArrowRight } from "lucide-react";

/** /portal/documente — toate documentele publicate, pe toate proiectele clientului. */
export default function ClientDocuments() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [project, setProject] = useState("all");
  const [pmOpen, setPmOpen] = useState(false);

  async function load() {
    setError(null);
    try { const { data } = await api.get("/client/documents"); setData(data); } catch (e) { setError(e); }
  }
  useEffect(() => { load(); }, []);

  const docs = (data?.documents || []).filter((d) => project === "all" || d.project_id === project);

  return (
    <PortalShell title="Documente" crumbs={[{ label: "Acasă", to: "/portal" }, { label: "Documente" }]}>
      <PageHeader title="Documente" description="Toate documentele publicate de echipa Brisk, pentru toate proiectele tale." />
      {error && !data ? <ErrorState onRetry={load} /> : !data ? <SkeletonRows rows={4} /> : (
        <div className="grid grid-cols-1 xl:grid-cols-[1fr_300px] gap-5 items-start">
          <div>
            {data.documents.length === 0 ? (
              <EmptyState icon={FileText} title="Niciun document publicat" description="Contractele, rapoartele lunare și avizele vor apărea aici pe măsură ce sunt publicate de echipă." testid="docs-empty" />
            ) : (
              <DocumentsTable documents={docs} showProject testid="all-docs-list" onChanged={load}
                extraFilter={data.projects.length > 1 && (
                  <Select value={project} onChange={(e) => setProject(e.target.value)} aria-label="Filtrează după proiect" className="!w-auto !h-9 min-w-[200px]" data-testid="docs-project-filter">
                    <option value="all">Toate proiectele</option>{data.projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </Select>
                )} />
            )}
          </div>
          <div className="space-y-4">
            <div className="cp-panel p-5 flex items-center gap-4" data-testid="docs-count">
              <IconTile icon={FileText} size="lg" />
              <div><div className="text-[13.5px] font-semibold text-cp-text">Documente publicate</div><div className="flex items-baseline gap-2 mt-0.5"><span className="cp-metric-lg">{String(docs.length).padStart(2, "0")}</span><span className="cp-meta">{project === "all" ? `în ${data.projects.length} ${data.projects.length === 1 ? "proiect" : "proiecte"}` : "în acest proiect"}</span></div></div>
            </div>
            <div className="cp-panel-navy p-5" data-testid="docs-help">
              <div className="flex items-start gap-3">
                <Users className="h-6 w-6 text-white/80 shrink-0 mt-0.5" aria-hidden="true" />
                <div><div className="text-[16px] font-semibold">Ai nevoie de un document?</div><p className="text-[13px] text-white/70 mt-1 leading-relaxed">Contactează managerul pentru asistență sau informații suplimentare.</p></div>
              </div>
              <Button onClick={() => setPmOpen(true)} className="w-full mt-4" data-testid="docs-contact">Contactează managerul <ArrowRight /></Button>
            </div>
          </div>
        </div>
      )}
      <PmContactModal open={pmOpen} onOpenChange={setPmOpen} />
    </PortalShell>
  );
}
